/**
 * Asynchronously loads the component for PiecripVerifyEmailPage
 */

import { lazyLoad } from '@utils/loadable';

export const PiecripVerifyEmailPage = lazyLoad(
  () => import('./index'),
  (module) => module.PiecripVerifyEmailPage,
);
